import { pipe, compose, ifElse, join, props, values, defaultTo, map, always, prop, has, propEq } from 'ramda';
import moment from 'moment-timezone';

import { BookingStatus } from '../services/booking/status';

export const isStatusPending = propEq('status', BookingStatus.PENDING);
export const isStatusPendingAlt = propEq('status', BookingStatus.PENDING_ALT);
export const isStatusPendingUserAltConfirm = propEq('status', BookingStatus.PENDING_USER_ALT_CONFIRM);
export const isStatusConfirmed = propEq('status', BookingStatus.CONFIRMED);
export const isStatusCompleted = propEq('status', BookingStatus.COMPLETED);

export const getDate = (tickets, timeZone) =>
  pipe(
    ifElse(has('confirmedDate'), always(prop('confirmedDate', tickets)), always(prop('date', tickets))),
    date =>
      moment
        .unix(date)
        .tz(timeZone)
        .format('DD MMMM YYYY')
  )(tickets);

export const formatTimeSlots = pipe(
  defaultTo({}),
  map(
    compose(
      join(' - '),
      props(['start', 'end'])
    )
  ),
  values,
  join(', ')
);

export const getTimeSlots = tickets =>
  pipe(
    ifElse(has('confirmedTimeSlot'), always({ timeSlot: prop('confirmedTimeSlot', tickets) }), prop('timeSlots')),
    formatTimeSlots
  )(tickets);
